import React, { Component, useState } from "react";
import Header from "../components/header";
import Feed from "../components/feed";
import Footer from "../components/footer";
import OnBoarding from "../components/onBoarging";

const Generator = (props) => {
  const [stepOnboarding, setStepOnboarding] = useState(0);
  const [showOnboarding, setShowOnboarding] = useState(false);
  useState(() => {
    if (!localStorage.getItem("ONBOARDING")) {
      setShowOnboarding(true);
      setStepOnboarding(1);
      localStorage.setItem("ONBOARDING", true);
    }
  }, []);

  return (
    <div className="relative">
      {showOnboarding && (
        <OnBoarding
          step={stepOnboarding}
          setStep={setStepOnboarding}
          setShowOnboarding={setShowOnboarding}
        />
      )}
      <div style={{ position: "relative", minHeight: "100vh" }}>
        <Header
          texts={props.texts}
          globalState={props.globalState}
          langHandler={props.langHandler}
        />
        <Feed
          globalState={props.globalState}
          stepOnboarding={stepOnboarding}
          setStepOnboarding={setStepOnboarding}
          texts={props.texts}
          changeRoute={(tab) => {
            let state_location =
              tab == "your_pic" ? props.context.location.state : {};
            props.context.history.push({
              pathname: `/generator`,
              search: `?page=${tab}`,
              state: { ...state_location },
            });
          }}
          {...props}
        />
        <Footer />
      </div>
    </div>
  );
};

export default Generator;
